import type { LngLatLike } from "maplibre-gl";

export type LatLngTuple = [number, number];
export type LngLatTuple = [number, number];

export const isValidLatLng = (location: unknown): boolean => {
  if (!Array.isArray(location) || location.length < 2) {
    return false;
  }

  const latitude = Number(location[0]);
  const longitude = Number(location[1]);
  return (
    Number.isFinite(latitude) &&
    Number.isFinite(longitude) &&
    latitude >= -85.05112878 &&
    latitude <= 85.05112878 &&
    longitude >= -180 &&
    longitude <= 180
  );
};

/** Converts the application's [latitude, longitude] tuples to MapLibre [longitude, latitude]. */
export const toLngLat = ([latitude, longitude]: LatLngTuple): LngLatTuple => [
  Number(longitude),
  Number(latitude),
];

export const toSafeLngLat = (
  location: LatLngTuple,
  fallback: LatLngTuple = [0, 0]
): LngLatTuple => toLngLat(isValidLatLng(location) ? location : fallback);

export const toMapLibreCenter = (location: LatLngTuple): LngLatLike =>
  toLngLat(location);

export const toLineCoordinates = (locations: LatLngTuple[]): LngLatTuple[] =>
  locations.map(toLngLat);
